import React from 'react';
import _ from 'lodash';
import {Grid} from 'semantic-ui-react';
import {
  TextBoxField,
  InlineSelect,
  RadioField,
  DollarField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {TextAreaFieldFrom as TextAreaField} from 'app-ui-componentlibrary';
import {InlineDollarFieldForm as InlineDollarField} from 'app-ui-componentlibrary';
import {RADIO_OPTIONS} from 'go/components/dynamic/modules/projectSiteInventory/constants';
import {mapLocationRefDataByIdAndCode} from 'common/utils';
import {
  isLocationBuildingInventoryType,
  isLocationInfrastructureInventoryType,
  getOptionText,
} from 'go/components/dynamic/modules/projectSiteInventory/utils';

const defaultSelected = {
  text: 'Select',
  value: null,
  key: 'select-default',
};

export class StructureAttributes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    // Populate dropdowns options for primary/secondary structure types if they're saved
    if (!_.isEqual(this.props.options, prevProps.options)) {
      this.setState(
        {
          options: this.props.options,
        },
        () => {
          if (this.props.inventoryItem.structure.structureTypePrimary) {
            this.handleStructureTypesNestedOptions(
              this.props.inventoryItem.structure.structureType,
              null
            );
          }
        }
      );
    }
    if (
      !_.isEqual(
        this.state.options.structureTypePrimaryIndicatorOptions,
        prevState.options.structureTypePrimaryIndicatorOptions
      )
    ) {
      if (this.props.inventoryItem.structure.structureTypeSecondary) {
        this.handleStructureTypesNestedOptions(
          this.props.inventoryItem.structure.structureType,
          this.props.inventoryItem.structure.structureTypePrimary
        );
      }
    }
  }

  // Get option id(key) from option display text
  getIdFromText = (optionText, optionName) => {
    let itemCodes = _.get(this.state.options, optionName, []);
    let value = _.filter(itemCodes, (item) => {
      return item.text === optionText;
    });
    if (_.size(value) > 0) return _.get(value, '0.id');
  };

  getIdFromKey = (optionKey, optionName) => {
    let itemCodes = _.get(this.state.options, optionName, []);
    let value = _.filter(itemCodes, (item) => {
      return item.key === optionKey;
    });

    if (_.size(value) > 0) return _.get(value, '0.id');
  };

  generateStructureTypeDropdownOptions = () => {
    const {locationType} = this.props;
    let optionsConfig = [];
    let stuctureTypeDropdownOptions = [];
    const structureTypesConfig = _.get(
      this.props.context.programCategoryConfig,
      'structures',
      null
    );

    const optionsRef = _.get(this.props.context, 'structureTypes.STRUCTURE_TYPE');

    /* const proprtyTypeId = _.toNumber(
      isLocationBuildingInventoryType(locationType)
        ? this.getIdFromText('Building', 'structureTypes')
        : isLocationInfrastructureInventoryType(locationType)
        ? this.getIdFromText('Infrastructure utility', 'structureTypes')
        : null
    );*/

    _.map(structureTypesConfig, (configItem) => {
      if (configItem.type === locationType) {
        optionsConfig = configItem.structureTypes;
      }
    });
    _.map(optionsConfig, (item) => {
      _.forEach(optionsRef, (option) => {
        if (option.id === item.structureTypeId) {
          stuctureTypeDropdownOptions.push(option);
        }
      });
    });
    // TODO set state and use it in handleStructureTypesNestedOptions
    // this.setState({
    //   structureTypesConfig,
    //   optionsRef,
    //   proprtyTypeId,
    //   optionsConfig
    // })
    return mapLocationRefDataByIdAndCode(stuctureTypeDropdownOptions, 'code');
  };

  // Generate dropdown options for structure types based on FO config structure
  handleStructureTypesNestedOptions = (value, secondLevelValue) => {
    const {locationType} = this.props;
    const selectedValue = _.toNumber(this.getIdFromKey(value, 'structureTypes'));

    const secondLevelVal = _.toNumber(
      this.getIdFromKey(secondLevelValue, 'structureTypes')
    );
    const optionsRef = _.get(this.props.context, 'structureTypes.STRUCTURE_TYPE');
    const proprtyTypeId = _.toNumber(
      isLocationBuildingInventoryType(locationType)
        ? this.getIdFromText('Building', 'structureTypes')
        : isLocationInfrastructureInventoryType(locationType)
        ? this.getIdFromText('Infrastructure utility', 'structureTypes')
        : null
    );
    const structureTypesConfig = _.get(
      this.props.context.programCategoryConfig,
      'structures',
      null
    );
    let selectedValueChildren = [],
      childrenChildren = [],
      generatedOptions = [],
      optionsConfig = [];

    _.map(structureTypesConfig, (configItem) => {
      if (configItem.inventoryType === proprtyTypeId) {
        optionsConfig = configItem.structureTypes;
      }
    });

    _.map(optionsConfig, (item) => {
      if (item.structureTypeId === selectedValue && !_.isEmpty(item.children)) {
        selectedValueChildren = item.children;

        if (!secondLevelVal) {
          _.forEach(selectedValueChildren, (child) => {
            _.forEach(optionsRef, (option) => {
              if (option.id === child.structureTypeId) {
                generatedOptions.push(option);
              }
            });
          });
        } else {
          _.forEach(selectedValueChildren, (child) => {
            if (child.structureTypeId === secondLevelVal && !_.isEmpty(child.children)) {
              childrenChildren = child.children;
            }
          });
          _.forEach(childrenChildren, (child) => {
            _.forEach(optionsRef, (option) => {
              if (option.id === child.structureTypeId) {
                generatedOptions.push(option);
              }
            });
          });
        }
      }
    });
    let structureTypePrimaryIndicatorOptions = [];
    let structureTypeSecondaryIndicatorOptions = [];
    if (secondLevelVal) {
      structureTypeSecondaryIndicatorOptions = mapLocationRefDataByIdAndCode(
        generatedOptions,
        'code'
      );
      this.setState({
        options: {
          ...this.state.options,
          structureTypeSecondaryIndicatorOptions: structureTypeSecondaryIndicatorOptions,
        },
      });
    } else {
      structureTypePrimaryIndicatorOptions = mapLocationRefDataByIdAndCode(
        generatedOptions,
        'code'
      );
      this.setState({
        options: {
          ...this.state.options,
          structureTypeSecondaryIndicatorOptions: [],
          structureTypePrimaryIndicatorOptions: structureTypePrimaryIndicatorOptions,
        },
      });
    }
    return {
      hasPrimaryIndicatorOptions: _.size(structureTypePrimaryIndicatorOptions) > 0,
      hasSecondaryIndicatorOptions: _.size(structureTypeSecondaryIndicatorOptions) > 0,
    };
  };

  render() {
    const {displayType, locationType, inventoryItem} = this.props;
    if (_.isEmpty(inventoryItem) || _.isEmpty(_.get(inventoryItem, 'structure')))
      return <p>No data available</p>;

    const {structure} = inventoryItem;
    const {options} = this.state;

    let otherFoundationDescription = '';
    const structureAdditionalInformation = _.get(
      inventoryItem.payload,
      'structureAdditionalInformation'
    );
    if (structureAdditionalInformation)
      otherFoundationDescription = _.get(
        structureAdditionalInformation,
        'otherFoundationDescription'
      );

    const {
      floodZone,
      alternateStructure,
      alternateLandLocation,
      critcalFacility,
      currentlyRented,
      estimatedPurchaseAmount,
      substantiallyDamaged,
      publiclyOwned,
      publiclyOwnedComments,
    } = inventoryItem.payload;

    const isBuilding = isLocationBuildingInventoryType(locationType);
    const isMitigationReconstruction =
      _.get(this.props, 'inventoryItem.payload.primaryMitigationAction') === 'MTRCN' ||
      _.get(this.props, 'inventoryItem.payload.secondaryMitigationActions') === 'MTRCN';
    const isElevation =
      _.get(this.props, 'inventoryItem.payload.primaryMitigationAction') === 'ELVTN' ||
      _.get(this.props, 'inventoryItem.payload.secondaryMitigationActions') === 'ELVTN';
    const isInfrastructure = isLocationInfrastructureInventoryType(locationType);

    const locationStructureTypeDisplay = isInfrastructure
      ? 'Infrastructure'
      : 'Structure';
    const floodZonePath = 'payload.floodZone';

    const floodZoneErrors = {
      display:
        this.props.displayError(floodZonePath) ||
        this.props.displayError(floodZonePath + '[0]'),
      message:
        this.props.getErrorMessage(floodZonePath, 'Flood zone') ||
        this.props.getErrorMessage(floodZonePath + '[0]', 'Flood zone'),
    };
    return (
      <div id="structure-attributes">
        <Grid>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="structure-type">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">{`${locationStructureTypeDisplay} type`}</p>
                    {getOptionText(
                      this.generateStructureTypeDropdownOptions(),
                      _.get(structure, 'structureType', '')
                    )}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form padding-top">
                    {options && (
                      <InlineSelect
                        id="structure-type-control"
                        label={`${locationStructureTypeDisplay} type`}
                        options={[
                          defaultSelected,
                          ..._.sortBy(
                            this.generateStructureTypeDropdownOptions(),
                            'text'
                          ),
                        ]}
                        name="structure.structureType"
                        aria-label="Required: Structure Type"
                        value={structure.structureType}
                        handleChange={(e) => {
                          const {name, value} = e.target;
                          const structureNestedOptions = this.handleStructureTypesNestedOptions(
                            value
                          );
                          this.props.handleStructureTypeChange(name, value, {
                            needsPrimary:
                              structureNestedOptions.hasPrimaryIndicatorOptions,
                            needsSecondary:
                              structureNestedOptions.hasSecondaryIndicatorOptions,
                          });
                        }}
                        handleBlur={this.props.handleBlur}
                        displayError={this.props.displayError('structure.structureType')}
                        errorMessages={this.props.getErrorMessage(
                          'structure.structureType',
                          'Structure type'
                        )}
                      />
                    )}
                  </div>
                )}
              </div>
            </Grid.Column>
            <Grid.Column mobile={16} computer={8}>
              {isBuilding ? (
                <div id="structure-foundation-type">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">Foundation type</p>
                      {getOptionText(
                        _.get(options, 'propertyFoundationTypes', []),
                        _.get(structure, 'foundationType', '')
                      )}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form padding-top">
                      {options && (
                        <InlineSelect
                          id="structure-foundation-type-control"
                          label="Foundation type"
                          options={[
                            defaultSelected,
                            ..._.sortBy(options.propertyFoundationTypes, 'displayOrder'),
                          ]}
                          name="structure.foundationType"
                          title="Required: Foundation type"
                          value={structure.foundationType}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError(
                            'structure.foundationType'
                          )}
                          errorMessages={this.props.getErrorMessage(
                            'structure.foundationType',
                            'Foundation type'
                          )}
                        />
                      )}
                    </div>
                  )}
                </div>
              ) : (
                ''
              )}
              {structure.foundationType === 'OTHER' ? (
                <div className="util--full-width ui form padding-top">
                  <Grid.Row>
                    <Grid.Column mobile={16} computer={8}>
                      <div id="other-foundation-description">
                        {displayType === 'view' ? (
                          <React.Fragment>
                            <p className="label">
                              Provide a detailed description of the foundation type
                            </p>
                            {otherFoundationDescription}
                          </React.Fragment>
                        ) : (
                          <div className="util--full-width ui form">
                            <TextAreaField
                              maxLength={4000}
                              id="owner-first-name-control"
                              label="Provide a detailed description of the foundation type"
                              title="Required: Provide a detailed description of the foundation type"
                              name="payload.structureAdditionalInformation.otherFoundationDescription"
                              value={
                                inventoryItem.payload.structureAdditionalInformation
                                  .otherFoundationDescription
                              }
                              handleChange={this.props.handleChange}
                              handleBlur={this.props.handleBlur}
                              displayError={this.props.displayError(
                                'payload.structureAdditionalInformation.otherFoundationDescription'
                              )}
                              errorMessages={this.props.getErrorMessage(
                                'payload.structureAdditionalInformation.otherFoundationDescription',
                                'Provide a detailed description of the foundation type'
                              )}
                            />
                          </div>
                        )}
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </div>
              ) : (
                ''
              )}
            </Grid.Column>

            <Grid.Column mobile={16} computer={8}>
              {options && _.size(options.structureTypePrimaryIndicatorOptions) > 0 && (
                <div id="structure-type-primary-indicator">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">Structure type primary indicator</p>
                      {getOptionText(
                        _.get(options, 'structureTypePrimaryIndicatorOptions', []),
                        _.get(structure, 'structureTypePrimary', '')
                      )}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form padding-top">
                      {options && (
                        <InlineSelect
                          id="structure-type-primary-indicator-control"
                          label="Structure type primary indicator"
                          options={[
                            defaultSelected,
                            ..._.sortBy(
                              options.structureTypePrimaryIndicatorOptions,
                              'text'
                            ),
                          ]}
                          name="structure.structureTypePrimary"
                          title="Required: Structure Type primary indicator"
                          value={structure.structureTypePrimary}
                          handleChange={(e) => {
                            const {name, value} = e.target;
                            const structureNestedOptions = this.handleStructureTypesNestedOptions(
                              structure.structureType,
                              value
                            );
                            this.props.handleStructureTypeChange(name, value, {
                              needsPrimary: true,
                              needsSecondary:
                                structureNestedOptions.hasSecondaryIndicatorOptions,
                            });
                          }}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError(
                            'structure.structureTypePrimary'
                          )}
                          errorMessages={this.props.getErrorMessage(
                            'structure.structureTypePrimary',
                            'Structure type primary indicator'
                          )}
                        />
                      )}
                    </div>
                  )}
                </div>
              )}
            </Grid.Column>
            <Grid.Column mobile={16} computer={8}>
              {isBuilding &&
                options &&
                _.size(options.structureTypePrimaryIndicatorOptions) > 0 &&
                _.size(options.structureTypeSecondaryIndicatorOptions) > 0 && (
                  <div id="structure-type-secondary-indicator">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">Structure type secondary indicator</p>
                        {getOptionText(
                          _.get(options, 'structureTypeSecondaryIndicatorOptions', []),
                          _.get(structure, 'structureTypeSecondary', '')
                        )}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form padding-top">
                        {options && (
                          <InlineSelect
                            id="structure-type-secondary-indicator-control"
                            label="Structure type secondary indicator"
                            options={[
                              defaultSelected,
                              ..._.sortBy(
                                options.structureTypeSecondaryIndicatorOptions,
                                'text'
                              ),
                            ]}
                            name="structure.structureTypeSecondary"
                            title="Required: Structure Type secondary indicator"
                            value={structure.structureTypeSecondary}
                            handleChange={(e) => {
                              const {name, value} = e.target;
                              this.props.handleStructureTypeChange(name, value, {});
                            }}
                            handleBlur={this.props.handleBlur}
                            displayError={this.props.displayError(
                              'structure.structureTypeSecondary'
                            )}
                            errorMessages={this.props.getErrorMessage(
                              'structure.structureTypeSecondary',
                              'Structure type secondary indicator'
                            )}
                          />
                        )}
                      </div>
                    )}
                  </div>
                )}
            </Grid.Column>
          </Grid.Row>
          {(isBuilding || isInfrastructure) && (
            <React.Fragment>
              <Grid.Row>
                {isBuilding && (
                  <Grid.Column mobile={16} computer={4}>
                    <div id="structure-building-size">
                      {displayType === 'view' ? (
                        <React.Fragment>
                          <p className="label">Building size (square feet)</p>
                          {structure.buildingSize}
                        </React.Fragment>
                      ) : (
                        <div className="util--full-width ui form">
                          <TextBoxField
                            id="structure-building-size-control"
                            label="Building size (square feet)"
                            title="Required: Building size"
                            name="structure.buildingSize"
                            value={structure.buildingSize}
                            handleChange={this.props.handleChangeNumerical}
                            handleBlur={this.props.handleBlur}
                            displayError={this.props.displayError(
                              'structure.buildingSize'
                            )}
                            errorMessages={this.props.getErrorMessage(
                              'structure.buildingSize',
                              'Building size (sq.ft)'
                            )}
                          />
                        </div>
                      )}
                    </div>
                  </Grid.Column>
                )}
                {
                  <Grid.Column mobile={16} computer={4}>
                    <div id="structure-year-built">
                      {displayType === 'view' ? (
                        <React.Fragment>
                          <p className="label">Year built</p>
                          {structure.yearBuilt}
                        </React.Fragment>
                      ) : (
                        <div className="util--full-width ui form">
                          <TextBoxField
                            maxLength={4}
                            id="structure-year-built-control"
                            label="Year built"
                            title="Required: Year built"
                            name="structure.yearBuilt"
                            value={structure.yearBuilt}
                            handleChange={this.props.handleChangeNumerical}
                            handleBlur={this.props.handleBlur}
                            displayError={this.props.displayError('structure.yearBuilt')}
                            errorMessages={this.props.getErrorMessage(
                              'structure.yearBuilt',
                              'Year built'
                            )}
                          />
                        </div>
                      )}
                    </div>
                  </Grid.Column>
                }
                <Grid.Column mobile={16} computer={8}>
                  <div id="tax-id-number">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">
                          Property tax identification number <span>(Optional)</span>
                        </p>
                        {structure.propertyTaxId}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          id="structure-year-built-control"
                          label="Property tax identification number"
                          optional={true}
                          title="Optional: Property tax identification number"
                          name="structure.propertyTaxId"
                          value={structure.propertyTaxId}
                          handleChange={this.props.handleChange}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} computer={16}>
                  <div id="structure-legal-description">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label half-col">
                          Legal description <span>(Optional)</span>
                        </p>
                        {structure.legalDescription}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextAreaField
                          maxLength={4001}
                          id="structure-legal-description-control"
                          label="Legal description"
                          title="Optional: Legal description"
                          optional={true}
                          name="structure.legalDescription"
                          value={structure.legalDescription}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError(
                            'structure.legalDescription'
                          )}
                          errorMessages={this.props.getErrorMessage(
                            'structure.legalDescription',
                            'Legal description'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                {isElevation && isBuilding && (
                  <Grid.Column mobile={16} computer={8}>
                    <div id="structure-first-floor-elevation">
                      {displayType === 'view' ? (
                        <React.Fragment>
                          <p className="label">First floor elevation (feet)</p>
                          {structure.firstFloorElevation}
                        </React.Fragment>
                      ) : (
                        <div className="util--full-width ui form">
                          <TextBoxField
                            id="structure-first-floor-elevation-control"
                            label="First floor elevation (feet)"
                            title="Required: First floor elevation (feet)"
                            name="structure.firstFloorElevation"
                            value={structure.firstFloorElevation}
                            handleChange={this.props.handleChangeNumerical}
                            handleBlur={this.props.handleBlur}
                            displayError={this.props.displayError(
                              'structure.firstFloorElevation'
                            )}
                            errorMessages={this.props.getErrorMessage(
                              'structure.firstFloorElevation',
                              'First floor elevation (feet)'
                            )}
                          />
                        </div>
                      )}
                    </div>
                  </Grid.Column>
                )}
                {isBuilding && (isElevation || isMitigationReconstruction) && (
                  <Grid.Column mobile={16} computer={8}>
                    <div id="structure-number-of-feet-the-lowest-floor-is-raised">
                      {displayType === 'view' ? (
                        <React.Fragment>
                          <p className="label">
                            Number of feet the lowest floor is proposed to be raised above
                            Base Flood Elevation
                          </p>
                          {structure.feetAboveBfe}
                        </React.Fragment>
                      ) : (
                        <div className="util--full-width ui form">
                          <TextBoxField
                            id="structure-first-floor-elevation-control"
                            label="Number of feet the lowest floor is proposed to be raised above Base Flood Elevation"
                            title="Required: Number of feet the lowest floor is proposed to be raised above Base Flood Elevation"
                            name="structure.feetAboveBfe"
                            value={structure.feetAboveBfe}
                            handleChange={this.props.handleChangeNumerical}
                            handleBlur={this.props.handleBlur}
                            displayError={this.props.displayError(
                              'structure.feetAboveBfe'
                            )}
                            errorMessages={this.props.getErrorMessage(
                              'structure.feetAboveBfe',
                              'Number of feet the lowest floor is raised'
                            )}
                          />
                        </div>
                      )}
                    </div>
                  </Grid.Column>
                )}
              </Grid.Row>
            </React.Fragment>
          )}
          {locationType == 'VACLAND' && (
            <React.Fragment>
              <Grid.Row>
                <Grid.Column mobile={16} computer={4}>
                  <div id="structure-lot-size">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">Lot size (in acres)</p>
                        {structure.lotSize}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          id="structure-lot-size-control"
                          label="Lot size (in acres)"
                          title="Required: Lot size"
                          name="structure.lotSize"
                          maxLength={6}
                          value={structure.lotSize}
                          handleChange={this.props.handleChangeNumerical}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError('structure.lotSize')}
                          errorMessages={this.props.getErrorMessage(
                            'structure.lotSize',
                            'Lot size (acres)'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
                <Grid.Column mobile={16} computer={8}>
                  <div id="tax-id-number">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">
                          Property tax identification number <span>(Optional)</span>
                        </p>
                        {structure.propertyTaxId}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextBoxField
                          id="structure-year-built-control"
                          label="Property tax identification number"
                          optional={true}
                          title="Optional: Property tax identification number"
                          name="structure.propertyTaxId"
                          value={structure.propertyTaxId}
                          handleChange={this.props.handleChange}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={16} computer={16}>
                  <div id="structure-legal-description">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label half-col">
                          Legal description <span>(Optional)</span>
                        </p>
                        {structure.legalDescription}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextAreaField
                          maxLength={8000}
                          id="structure-legal-description-control"
                          label="Legal description"
                          title="Optional: Legal description"
                          optional={true}
                          name="structure.legalDescription"
                          value={structure.legalDescription}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError(
                            'structure.legalDescription'
                          )}
                          errorMessages={this.props.getErrorMessage(
                            'structure.legalDescription',
                            'Legal description'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
            </React.Fragment>
          )}
          <Grid.Row>
            {floodZone && (
              <Grid.Column mobile={16} computer={8}>
                <div id="structure-flood-zone">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">Flood zone</p>
                      {getOptionText(
                        _.get(options, 'floodZoneTypes', []),
                        _.get(floodZone, '0', '')
                      )}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      {options && (
                        <InlineSelect
                          id="structure-foundation-type-control"
                          label="Flood zone"
                          options={[
                            defaultSelected,
                            ..._.sortBy(options.floodZoneTypes, 'text'),
                          ]}
                          name="payload.floodZone[0]"
                          aria-label="Required: Flood zone"
                          value={floodZone[0]}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={floodZoneErrors.display}
                          errorMessages={floodZoneErrors.message}
                        />
                      )}
                    </div>
                  )}
                </div>
              </Grid.Column>
            )}
            {
              <Grid.Column mobile={16} computer={8}>
                <div id="structure-base-flood-elevation">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">
                        Base flood elevation (feet) <span>(Optional)</span>
                      </p>
                      {structure.baseFloodElevation}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      <TextBoxField
                        id="structure-base-flood-elevation-control"
                        label="Base flood elevation (feet)"
                        title="Optional: Base flood elevation (feet)"
                        optional={true}
                        maxLength={8}
                        name="structure.baseFloodElevation"
                        value={structure.baseFloodElevation}
                        handleChange={this.props.handleChangeNumerical}
                        handleBlur={this.props.handleBlur}
                        displayError={this.props.displayError(
                          'structure.baseFloodElevation'
                        )}
                        errorMessages={this.props.getErrorMessage(
                          'structure.baseFloodElevation',
                          'Base flood elevation (feet)'
                        )}
                      />
                    </div>
                  )}
                </div>
              </Grid.Column>
            }
          </Grid.Row>
          {(isBuilding || isInfrastructure || locationType === 'VACLAND') && (
            <Grid.Row>
              <Grid.Column mobile={16} computer={8}>
                <div id="structure-estimated-purchase-offer-amount">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">Estimated cost of mitigation ($)</p>
                      {estimatedPurchaseAmount}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      <DollarField
                        alignLeft
                        label="Estimated cost of mitigation ($)"
                        id="structure-estimated-purchase-offer-amount-control"
                        title="Required: Estimated cost of mitigation ($)"
                        name="payload.estimatedPurchaseAmount"
                        value={estimatedPurchaseAmount}
                        handleBlur={() =>
                          this.props.saveCostMitigation(`payload.estimatedPurchaseAmount`)
                        }
                        handleChange={(name, value) =>
                          this.props.handleChangeOnDollarAmount(name, value)
                        }
                        displayError={this.props.displayError(
                          'payload.estimatedPurchaseAmount'
                        )}
                        errorMessages={this.props.getErrorMessage(
                          'payload.estimatedPurchaseAmount',
                          'Estimated cost of mitigation ($)'
                        )}
                      />
                    </div>
                  )}
                </div>
              </Grid.Column>
            </Grid.Row>
          )}
          {locationType == 'VACLAND' && (
            <React.Fragment>
              <Grid.Row>
                <Grid.Column mobile={16} computer={4}>
                  <div id="structure-land-proposed-use">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">Proposed use</p>
                        {structure.landProposedUse}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <InlineSelect
                          options={[
                            defaultSelected,
                            ..._.sortBy(options.landUseTypes, 'displayOrder'),
                          ]}
                          id="structure-other-proposed-use-control"
                          value={structure.landProposedUse}
                          label="Proposed use"
                          title="Proposed use"
                          name="structure.landProposedUse"
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError(
                            'structure.otherLandProposedUse'
                          )}
                          errorMessages={this.props.getErrorMessage(
                            'structure.landProposedUse',
                            'Proposed use'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
              {structure.landProposedUse === 'OTHR' && (
                <Grid.Row>
                  <Grid.Column mobile={16} computer={16}>
                    <div id="structure-other-proposed-use">
                      {displayType === 'view' ? (
                        <React.Fragment>
                          <p className="label">Other proposed use</p>
                          {structure.otherLandProposedUse}
                        </React.Fragment>
                      ) : (
                        <div className="util--full-width ui form">
                          {options && (
                            <TextAreaField
                              id="structure-land-proposed-use-control"
                              maxLength={4000}
                              label="Other proposed use"
                              title="Other proposed use"
                              name="structure.otherLandProposedUse"
                              value={structure.otherLandProposedUse}
                              handleChange={this.props.handleChange}
                              handleBlur={this.props.handleBlur}
                              displayError={this.props.displayError(
                                'structure.otherLandProposedUse'
                              )}
                              errorMessages={this.props.getErrorMessage(
                                'structure.otherLandProposedUse',
                                'Other proposed use'
                              )}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </Grid.Column>
                </Grid.Row>
              )}
            </React.Fragment>
          )}
          <Grid.Row>
            {(isBuilding || locationType === 'VACLAND') && (
              <Grid.Column mobile={16} computer={8}>
                <div id="structure-is-structure-rented">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">Is this structure currently rented/leased?</p>
                      {currentlyRented ? 'Yes' : 'No'}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      <RadioField
                        id="structure-is-structure-rented-control"
                        label="Is this structure currently rented/leased?"
                        title="Required: Is this structure currently rented/leased?"
                        name="payload.currentlyRented"
                        value={currentlyRented}
                        handleChange={this.props.handleChangeBoolean}
                        handleBlur={this.props.handleBlur}
                        options={RADIO_OPTIONS}
                        displayError={this.props.displayError('payload.currentlyRented')}
                        errorMessages={this.props.getErrorMessage(
                          'payload.currentlyRented',
                          'Is this structure currently rented/leased?'
                        )}
                      />
                    </div>
                  )}
                </div>
              </Grid.Column>
            )}
            {!(locationType === 'VACLAND') && (
              <Grid.Column mobile={16} computer={8}>
                <div id="structure-isStructure-critical-facility">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">
                        Is this a critical facility as identified in your hazard
                        mitigation plan?
                      </p>
                      {critcalFacility ? 'Yes' : 'No'}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      <RadioField
                        id="structure-isStructure-critical-facility-control"
                        label="Is this a critical facility as identified in your hazard mitigation plan?"
                        title="Required: Is this a critical facility as identified in your hazard mitigation plan?"
                        name="payload.critcalFacility"
                        value={critcalFacility}
                        handleChange={this.props.handleChangeBoolean}
                        handleBlur={this.props.handleBlur}
                        options={RADIO_OPTIONS}
                        displayError={this.props.displayError('payload.critcalFacility')}
                        errorMessages={this.props.getErrorMessage(
                          'payload.critcalFacility',
                          'Is this a critical facility as identified in your hazard mitigation plan?'
                        )}
                      />
                    </div>
                  )}
                </div>
              </Grid.Column>
            )}
          </Grid.Row>
          {(isBuilding || isInfrastructure) && (
            <Grid.Row>
              <Grid.Column mobile={16} computer={8}>
                <div id="structure-isStructure-identified-alternate-structure">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">
                        Is this structure identified as an alternate structure?
                      </p>
                      {alternateStructure ? 'Yes' : 'No'}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      <RadioField
                        id="structure-isStructure-identified-alternate-structure-control"
                        label="Is this structure identified as an alternate structure?"
                        title="Required: Is this structure identified as an alternate structure?"
                        name="payload.alternateStructure"
                        value={alternateStructure}
                        handleChange={this.props.handleChangeBoolean}
                        handleBlur={this.props.handleBlur}
                        options={RADIO_OPTIONS}
                        displayError={this.props.displayError(
                          'payload.alternateStructure'
                        )}
                        errorMessages={this.props.getErrorMessage(
                          'payload.alternateStructure',
                          'Is this structure identified as an alternate structure?'
                        )}
                      />
                    </div>
                  )}
                </div>
              </Grid.Column>
              {locationType !== 'VACLAND' && isBuilding && (
                <Grid.Column mobile={16} computer={8}>
                  <div id="structure-isStructure-substantially-damaged">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">Is this structure substantially damaged?</p>
                        {substantiallyDamaged ? 'Yes' : 'No'}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <RadioField
                          id="structure-isStructure-substantially-damaged-control"
                          label="Is this structure substantially damaged?"
                          title="Required: Is this structure substantially damaged?"
                          name="payload.substantiallyDamaged"
                          value={substantiallyDamaged}
                          handleChange={this.props.handleChangeBoolean}
                          handleBlur={this.props.handleBlur}
                          options={RADIO_OPTIONS}
                          displayError={this.props.displayError(
                            'payload.substantiallyDamaged'
                          )}
                          errorMessages={this.props.getErrorMessage(
                            'payload.substantiallyDamaged',
                            'Is this structure substantially damaged?'
                          )}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              )}
            </Grid.Row>
          )}
          {isInfrastructure && (
            <Grid.Row>
              <Grid.Column mobile={16} computer={8}>
                <div id="structure-isInfrastructure-publicly-owned">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">Is this structure publicly owned?</p>
                      {publiclyOwned ? 'Yes' : 'No'}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      <RadioField
                        id="structure-isInfrastructure-publicly-owned-control"
                        label="Is this structure publicly owned?"
                        title="Required: Is this structure publicly owned?"
                        name="payload.publiclyOwned"
                        value={publiclyOwned}
                        handleChange={this.props.handleChangeBoolean}
                        handleBlur={this.props.handleBlur}
                        options={RADIO_OPTIONS}
                        displayError={this.props.displayError('payload.publiclyOwned')}
                        errorMessages={this.props.getErrorMessage(
                          'payload.publiclyOwned',
                          'Is this structure publicly owned?'
                        )}
                      />
                    </div>
                  )}
                </div>
              </Grid.Column>
              {isInfrastructure && publiclyOwned && (
                <Grid.Column mobile={16} computer={16}>
                  <div id="structure-publicly-owned-comments" className="indent_1">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">
                          Comments <span>(Optional)</span>
                        </p>
                        {publiclyOwnedComments}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <TextAreaField
                          maxLength={1000}
                          id="structure-publicly-owned-comments-control"
                          label="Comments"
                          optional={true}
                          title="Optional: comments"
                          name="payload.publiclyOwnedComments"
                          value={publiclyOwnedComments}
                          handleChange={this.props.handleChange}
                        />
                      </div>
                    )}
                  </div>
                </Grid.Column>
              )}
            </Grid.Row>
          )}
          {locationType === 'VACLAND' && (
            <Grid.Column mobile={16} computer={8}>
              <div id="structure-land-as-alternate-location">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">
                      Is this structure identified as an alternate location?
                    </p>
                    {alternateLandLocation ? 'Yes' : 'No'}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <RadioField
                      id="structure-isStructure-identified-alternate-location-control"
                      label="Is this vacant land identified as an alternate location?"
                      title="Required: Is this vacant land identified as an alternate location?"
                      name="payload.alternateLandLocation"
                      value={alternateLandLocation}
                      handleChange={this.props.handleChangeBoolean}
                      handleBlur={this.props.handleBlur}
                      options={RADIO_OPTIONS}
                      displayError={this.props.displayError(
                        'payload.alternateLandLocation'
                      )}
                      errorMessages={this.props.getErrorMessage(
                        'payload.alternateLandLocation',
                        'Is this vacant land identified as an alternate location?'
                      )}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          )}
        </Grid>
      </div>
    );
  }
}

export default StructureAttributes;
